import { render, staticRenderFns } from "./RawMaterialStockInventory.vue?vue&type=template&id=00b60b46&scoped=true&"
import script from "./RawMaterialStockInventory.vue?vue&type=script&lang=js&"
export * from "./RawMaterialStockInventory.vue?vue&type=script&lang=js&"
import style0 from "./RawMaterialStockInventory.vue?vue&type=style&index=0&id=00b60b46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b60b46",
  null
  
)

export default component.exports